import { PhasrRecommendationsController } from '../controller/PhasrRecommendationsController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class PhasrRecommendationsWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrRecommendationsController,
    });
  }
}
